import { createSlice } from "@reduxjs/toolkit";

const profitLossSlice = createSlice({
    name: "profitLoss",
    initialState: {
        profitLossData: {},  // Stores individual row profits
        totalProfitLoss: 0,   // Stores the total profit across all rows
        updatePL: 0
    },
    reducers: {
        updateProfitLoss: (state, action) => {
            state.updatePL++;
        },
        addProfitLoss: (state, action) => {
            state.profitLossData = action.payload
        }
    }
});

export const { updateProfitLoss, addProfitLoss } = profitLossSlice.actions;
export default profitLossSlice.reducer;
